import React from 'react';
import { useTranslation } from 'react-i18next';
import { PRICING } from '../../constants';
import './MenuSelection.css';

/**
 * Menu selection section component
 */
const MenuSelection: React.FC = () => {
  const { t } = useTranslation();
  
  // Get translated protein names
  const baseProteins = [
    t('menu.chicken', 'Chicken'),
    t('menu.steak', 'Steak'),
    t('menu.shrimp', 'Shrimp'),
    t('menu.salmon', 'Salmon'),
    t('menu.tofu', 'Tofu'),
  ].join(', ');
  
  return (
    <section className="menu-selection">
      <h2>{t('menuSelection.title', 'SELECT YOUR DISH TYPE')}</h2>
      <p>{t('menuSelection.subtitle', 'All meals include steamed rice, hibachi vegetables, and signature sauces')}</p>

      <div className="menu-options">
        <div className="menu-option">
          <h3>{t('menuSelection.regular.title', 'REGULAR')}</h3>
          <p>{t('menuSelection.regular.proteins', '2 proteins per person')}: {baseProteins}</p>
          <p>{t('menuSelection.regular.service', 'Show included, 90 min service')}</p>
          <p className="price">${PRICING.PER_PERSON}/{t('pricing.perPerson', 'person')}</p>
        </div>

        <div className="menu-option premium">
          <h3>{t('menuSelection.premium.title', 'PREMIUM')}</h3>
          <p>{t('menuSelection.premium.proteins', '2 premium proteins: Filet Mignon, Lobster, Scallops')}</p>
          <p>{t('menuSelection.premium.service', 'Show included, 120 min service')}</p>
          <p className="price">$80/{t('pricing.perPerson', 'person')}</p>
        </div>

        <div className="menu-option">
          <h3>{t('menuSelection.catering.title', 'LARGE GATHERING')}</h3>
          <p>{t('menuSelection.catering.note', '50+ guests buffet style')}</p>
          <p>{t('menuSelection.catering.proteins', '2 proteins per person')}: {baseProteins}</p>
          <p>{t('menuSelection.catering.service', 'Shows included, 3-4 hours service')}</p>
          <p className="price">$45/{t('pricing.perPerson', 'person')}</p>
        </div>

        <div className="menu-option">
          <h3>{t('menuSelection.intimate.title', 'INTIMATE PARTY')}</h3>
          <p>{t('menuSelection.intimate.note', '5-7 guests')}</p>
          <p>{t('menuSelection.intimate.includes', 'Salads, gyoza, edamame, noodles + mixed proteins')}</p>
          <p>{t('menuSelection.intimate.substitution', 'Same-price proteins can be substituted')}</p>
          <p className="price">${PRICING.MINIMUM_ORDER} {t('common.total', 'Total')}</p>
        </div>
      </div>
    </section>
  );
};

export default MenuSelection;


